import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

export default function Faq() {
  const { content } = useContent();
  if (!content) return <section id="faq" className="py-16 md:py-28" />;
  const faqs = content.faqs || [];

  return (
    <section id="faq" className="section-fade py-16 md:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="FAQ"
          title="Questions, answered"
          sub="Everything you need to know about ordering and streaming with IPTV HUB."
        />
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <AccordionItem value={`faq-${i}`} className="faq-item border-0" data-testid={`faq-item-${i + 1}`}>
                <AccordionTrigger className="faq-trigger px-6 py-5 text-left font-display text-base font-semibold text-slate-900 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-sm leading-relaxed text-slate-500">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
